module.exports = __webpack_public_path__ + "static/media/Logo Design.31e06496.svg";